"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_AUTH_STATE = void 0;
var sub_events_1 = require("sub-events");
var Errors_1 = require("./Errors");
exports.DEFAULT_AUTH_STATE = {
    authenticated: false,
    access_token: "",
    refresh_token: "",
    expires_at: "",
    refreshing_now: false,
    no_refresh: true
};
var AuthManager = /** @class */ (function () {
    function AuthManager(chariot) {
        this.chariot = chariot;
        this.state = exports.DEFAULT_AUTH_STATE;
        this.onAuthUpdated = new sub_events_1.SubEvent();
    }
    AuthManager.prototype.getOptions = function () {
        var _a = this.chariot.options, domain = _a.domain, cors = _a.cors, allowAuthenticatedRequestsBeforeAuthentication = _a.allowAuthenticatedRequestsBeforeAuthentication;
        if (domain.replace(/[^\w.-]/g, "") !== domain) {
            throw new Errors_1.ValidationError("Chariot domain must not include protocol or path.");
        }
        return {
            domain: domain,
            cors: cors,
            allowAuthenticatedRequestsBeforeAuthentication: allowAuthenticatedRequestsBeforeAuthentication
        };
    };
    AuthManager.prototype.getState = function () {
        return this.state;
    };
    AuthManager.prototype.setState = function (newAuthState, emitEvent) {
        if (emitEvent === void 0) { emitEvent = true; }
        this.state = __assign(__assign({}, this.state), newAuthState);
        if (emitEvent)
            this.onAuthUpdated.emit(this.state);
    };
    AuthManager.prototype.resetState = function () {
        this.state = exports.DEFAULT_AUTH_STATE;
        this.onAuthUpdated.emit(this.state);
    };
    AuthManager.prototype.waitForNextToken = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var subscription = _this.onAuthUpdated.subscribe(function (newAuthState) {
                if (newAuthState.authenticated) {
                    subscription.cancel();
                    resolve([newAuthState.access_token, newAuthState]);
                }
            });
        });
    };
    return AuthManager;
}());
exports.default = AuthManager;
